





























































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Acompanhamento, PacientePutFormData } from '../../../../back/src/types';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';
import { Usuario } from '../../../../back/src/entity/Usuario';
import { gruposIds } from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesCadastroInternoAcompanhamento',
  components: {
    Carregando,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      required: true,
    },
  },
  data() {
    return {
      loading: {
        form: false,
        usuarios: true,
        submit: false,
      },
      valid: false,
      usuarios: [],
      cancelar: false,
      reativar: false,
      form: {
        acompanhamento: null,
        responsavelId: null,
        justificativaCancelamento: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
      acompanhamentoItens: [
        { value: null, text: 'Em triagem' },
        { value: Acompanhamento.COLETIVO, text: 'Coletivo Nascer' },
        { value: Acompanhamento.CASA_DE_PARTO, text: 'Casa de Parto' },
        { value: Acompanhamento.PARTICULAR, text: 'Particular' },
      ],
      Acompanhamento,
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    classActions(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    formAcompanhamento(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formAcompanhamento as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
    usuariosItens() {
      return _.orderBy(
        _.map(
          _.filter(
            this.usuarios as Usuario[],
            usuario => !usuario.email.includes('@kemiocode'),
          ),
          usuario => ({ value: usuario.id, text: usuario.nome }),
        ),
        ['text'],
      );
    },
  },
  mounted() {
    this.buscaUsuarios();
  },
  methods: {
    preencheForm() {
      this.loading.form = true;
      this.form.acompanhamento = this.paciente.acompanhamento;
      this.form.responsavelId = this.paciente.responsavel_id;
      this.loading.form = false;
    },
    async buscaUsuarios() {
      this.loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios({
          grupo_id: [
            gruposIds.MÉDICAS,
            gruposIds.DIREÇÃO,
            gruposIds.OBSTETRIZES,
          ],
          ativo: 'true',
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuarios = false;
      }
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
      this.cancelar = false;
      this.reativar = false;
      this.formAcompanhamento.resetValidation();
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formAcompanhamento.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: PacientePutFormData = {
        id: this.paciente.id,
        acompanhamento: this.form.acompanhamento,
        responsavel_id: this.form.acompanhamento === Acompanhamento.PARTICULAR
          ? this.form.responsavelId
          : null,
      };
      if (this.cancelar) {
        formData.justificativa_cancelamento = this.form.justificativaCancelamento;
      } else if (this.reativar) {
        formData.justificativa_cancelamento = null;
      }
      try {
        const response = await Requester.paciente.alteraPaciente(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaPaciente', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Paciente atualizada com sucesso!' });
          this.cancelar = false;
          this.reativar = false;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
